import { OktaAuth } from '@okta/okta-auth-js'

// constants
import { OKTA_CONFIG, JANSSEN_OKTA_CONFIG } from './okta.constants'

const oktaAuth = new OktaAuth(OKTA_CONFIG)

const janssenOktaAuth = new OktaAuth(JANSSEN_OKTA_CONFIG)

export {
    oktaAuth as applicationAuthClient,
    janssenOktaAuth as janssenApplicationAuthClient
}
